import React, { useEffect, useState ,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  SetExitNoDueEditActions,
  SetTheExitRetrieveActions,
} from "../../../Redux/Slice";
import html2pdf from "html2pdf.js";
import "../../../StyleSheet/MainComponent/ExitFlow/HrInterview.scss";
// import { cl } from "@fullcalendar/core/internal-common";
import jsPDF from "jspdf";
import { useReactToPrint } from 'react-to-print';
import $ from "jquery";
import html2canvas from 'html2canvas';

const HrinterviewForm = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigator = useNavigate();
  const state = useSelector((state) => state);
  const [formDirty, setFormDirty] = useState(false);
  const contentRef = useRef(null);

  const [data, setData] = useState({
    question_1: "",
    question_2: "",
    question_3: "",
    question_4: "",
    question_5: "",
    question_6: [],
    question_7: false,
    question_8: { checkboxAnswers: {}, inputAnswers: {} },
    question_9: "",
    question_10: "",
  });
  // -----------Question-6---------
  const options = [
    "Compensation and benefits",
    "Opportunity for advancement & growth",
    "More desirable location",
    "More responsibility",
    "Opportunity to work on good projects industry",
    "Working for a Big Name",
    "More job flexibility",
    "Others (please specify)",
  ];
  // -----------Question-8---------
  const [checkboxAnswers, setCheckboxAnswers] = useState({
    "Performance reviews": true,
    "Opportunity for advancement & growth": true,
    "Training received": true,
    "Company policies and practices": true,
    "Your job responsibilities": true,
    "Support you received from superiors & management": true,
    "Your compensation & benefits": true,
    "Transparency in company’s processes": true,
    "Internal Communication": true,
  });

  const [inputAnswers, setInputAnswers] = useState({
    "Performance reviews": "",
    "Opportunity for advancement & growth": "",
    "Training received": "",
    "Company policies and practices": "",
    "Your job responsibilities": "",
    "Support you received from superiors & management": "",
    "Your compensation & benefits": "",
    "Transparency in company’s processes": "",
    "Internal Communication": "",
  });
  const questions = [
    { label: "Performance reviews" },
    { label: "Opportunity for advancement & growth" },
    { label: "Training received" },
    { label: "Company policies and practices" },
    { label: "Your job responsibilities" },
    { label: "Support you received from superiors & management" },
    { label: "Your compensation & benefits" },
    { label: "Transparency in company’s processes" },
    { label: "Internal Communication" },
  ];
  // -----------Question-1 to 5---------
  const questionsWithNames = [
    {
      name: "question_1",
      label: "1. What are your primary reasons for leaving UDS?",
    },
    {
      name: "question_2",
      label:
        "2. Is there anything the company could have done to prevent you from leaving?",
    },
    {
      name: "question_3",
      label: "3. Were you comfortable talking to your Manager?",
    },
    {
      name: "question_4",
      label: "4. What are things your Manager could have done to mentor you?",
    },
    {
      name: "question_5",
      label: "5. Would you recommend UDS to a friend as a good place to work?",
    },
  ];
  // -----------Question-9 to 10---------

  const questionsWithNamesPart = [
    {
      name: "question_9",
      label: "9. Did you enjoy the culture of the organization?",
    },
    {
      name: "question_10",
      label: "10.Would you care to make any other comments?",
    },
  ];

  const dispatch = useDispatch();
  useEffect(() => {
    const payload = {
      EditId: state.ClientBranchIDs.Exit_No_dueData.id,
    };
    dispatch(SetTheExitRetrieveActions(payload));
  }, [dispatch]);
  const handleSubmitChanges = () => {
    const payload = {
      id: state.ExitRetrieveCall.ExitDataRetrieve.id,
      data: { hr_interview: data },
    };
    dispatch(SetExitNoDueEditActions(payload));
    setFormDirty(false);
  };
  // const handlePrint = () => {
    // const element = document.getElementById("printableDiv");
    // const eightquestions =
    // document.getElementById("EightQuestions").style.margin = "140px 0px 0px 0px";

    // useReactToPrint({ contentRef })

    // html2pdf().from(element).save();
    // document.body.style.zoom = `102%`;

    // // const element = document.getElementsByClassName("HrForm")[0]; // Get the first element
    // html2canvas(element).then((canvas) => {
    //   const imgData = canvas.toDataURL('image/png');
    //   const pdf = new jsPDF();
    //   const imgWidth = 190; // Set width for PDF
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   let heightLeft = imgHeight;
    //   document.body.style.zoom = `102%`;

    //   let position = 0;
    //   // Add the image to the PDF
    //   pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    //   heightLeft -= pdf.internal.pageSize.height;

    //   // If the content is taller than one page, add more pages
    //   while (heightLeft >= 0) {
    //     position = heightLeft - imgHeight;
    //     pdf.addPage();
    //     pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    //     heightLeft -= pdf.internal.pageSize.height;
    //   }
    //   const zoom = (window.innerWidth / 1820) * 100;
    //   document.body.style.zoom = `${Math.round(zoom)}%`;
    //     // Save the PDF
    //   pdf.save('exitinterviewform.pdf');
    // });


    // document.getElementById("EightQuestions").style.margin = "0px";

// if (element) {
    //   // Save the original styles to restore them after printing
    //   const originalStyles = element.style.cssText;
  
    //   // Hide all other elements on the page except the target element
    //   const allElements = document.body.children;
    //   for (let i = 0; i < allElements.length; i++) {
    //     if (allElements[i] !== element) {
    //       allElements[i].style.visibility = 'hidden';  // Hide other elements
    //     }
    //   }
  
    //   // Center the target element on the screen
    //   // element.style.position = "fixed";
    //   // element.style.top = "10%";        // Position at the top of the viewport
    //   // element.style.left = "10%";       // Align to the left of the viewport
    //   // element.style.margin = "0";     // Remove any margins
    //   // element.style.visibility = "visible"; // Ensure the target element is visible
    //   element.style.position = "fixed";
    // element.style.top = "4%";
    // element.style.left = "50%";
    // element.style.transform = "translateX(-50%)"; // Center horizontally
    // element.style.width = "100%";
    // element.style.overflow ="scroll"
    // element.style.maxWidth = "1000px"; // Set a max width for better formatting
    // element.style.margin = "0 auto";
    // element.style.visibility = "visible"; // Ensure the target element is visible


  
    //   // Print the visible element
    //   window.print();
  
    //   // Restore original styles and visibility of all elements after printing
    //   element.style.cssText = originalStyles;
    //   for (let i = 0; i < allElements.length; i++) {
    //     allElements[i].style.visibility = ''; // Reset to original visibility
    //   }
    // }

    // if (element) {
    //   // Save the original styles to restore them after printing
    //   const originalStyles = element.style.cssText;
  
    //   // Hide all other elements on the page except the target element
    //   const allElements = document.body.children;
    //   for (let i = 0; i < allElements.length; i++) {
    //     if (allElements[i] !== element) {
    //       allElements[i].style.visibility = 'hidden';  // Hide other elements
    //     }
    //   }
  
    //   // Apply styling to center and make the target element scrollable
    //   element.style.position = "fixed";
    //   element.style.top = "4%";
    //   element.style.left = "50%";
    //   element.style.transform = "translateX(-50%)"; // Center horizontally
    //   element.style.width = "100%";
    //   element.style.maxWidth = "1000px"; // Set a max width for better formatting
    //   element.style.height = "auto"; // Set a fixed height for the print area
    //   element.style.overflow = "auto"; // Enable scrolling within the element
    //   element.style.padding = "10px"; // Optional padding for better readability
    //   element.style.boxSizing = "border-box"; // Ensures padding doesn’t affect width
    //   element.style.visibility = "visible"; // Ensure the target element is visible
  
    //   // Print the visible element
    //   window.print();
  
    //   // Restore original styles and visibility of all elements after printing
    //   element.style.cssText = originalStyles;
    //   for (let i = 0; i < allElements.length; i++) {
    //     allElements[i].style.visibility = ''; // Reset to original visibility
    //   }
    // }

    const handlePrint = useReactToPrint({
      content: () => contentRef.current,
    });
  
  





  // };
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setData({
        ...data,
        [event.target.name]: [...data[event.target.name], value],
      });
      // setFormDirty(true);
    } else {
      setData({
        ...data,
        [event.target.name]: data.question_6.filter(
          (option) => option !== value
        ),
      });
    }
    setFormDirty(true);
  };

  const handleRateCheckboxChange = (question, value) => {
    setFormDirty(true);
    setCheckboxAnswers((prevState) => ({
      ...prevState,
      [question]: value,
    }));
  };

  useEffect(() => {
    setData({
      ...data,
      question_8: {
        checkboxAnswers: checkboxAnswers,
        inputAnswers: inputAnswers,
      },
    });
  }, [checkboxAnswers, inputAnswers]);

  const handleInputChange = (question, value) => {
    setFormDirty(true);
    setInputAnswers((prevState) => ({
      ...prevState,
      [question]: value,
    }));
  };

  const handleTextChange = (e) => {
    setFormDirty(true);
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  useEffect(() => {
    const payload = {
      EditId: state.ClientBranchIDs.Exit_No_dueData.id,
    };
    dispatch(SetTheExitRetrieveActions(payload));
  }, [dispatch]);
  useEffect(() => {
    // console.log(
    //   state.ClientBranchIDs.Exit_No_dueData,
    //   "Exit_No_dueData",
    //   state.ExitRetrieveCall.ExitDataRetrieve
    // );
    if (
      state.ExitRetrieveCall.ExitDataRetrieve.hr_interview != undefined &&
      state.ExitRetrieveCall.ExitDataRetrieve.hr_interview !== null
    ) {
      console.log(
        state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_1,
        "hr_interviewhr_interviewhr_interviewhr_interviewhr_interview"
      );
      // setData({
      //   ...data,
      //   question_1:
      //     state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_1,
      // });
      setData((prevData) => ({
        ...prevData,
        question_1:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_1,
        question_2:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_2,
        question_3:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_3,
        question_4:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_4,
        question_5:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_5,
        question_6:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_6,
        question_7:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_7,
        question_8:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_8,
        question_9:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_9,
        question_10:
          state.ExitRetrieveCall.ExitDataRetrieve.hr_interview.question_10,
      }));
      // setCheckboxAnswers(
      //   state.ExitRetrieveCall.ExitDataRetrieve.hr_interview?.question_8
      //     .checkboxAnswers
      // );
      setCheckboxAnswers((prevData) => ({
        ...prevData,
        ...state.ExitRetrieveCall.ExitDataRetrieve.hr_interview?.question_8
          .checkboxAnswers,
      }));
      // setInputAnswers(
      //   state.ExitRetrieveCall.ExitDataRetrieve.hr_interview?.question_8
      //     .inputAnswers
      // );
    }
  }, [state.ExitRetrieveCall.ExitDataRetrieve]);
  useEffect(() => {
    console.log(checkboxAnswers, "datatatattat");
  }, [checkboxAnswers]);
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="row noDue"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            gap: "12px",
            padding: "20px 30px",
          }}
        >
          <button
            className="ButtonCSS"
            onClick={() => {
              navigator("/nodue");
            }}
          >
            {"Back"}
          </button>

          <button
            className="ButtonCSS"

            onClick={() => {
              formDirty ? handleSubmitChanges() : handlePrint();
            }}
          >
            {formDirty ? "Update Change" : "Print PDF"}
          </button>
        </div>
        <div className="coverDiv" style={{width:"90%"}}>
          <div id="printableDiv" className="HRINTERVIEWFORM" ref={contentRef}>
            <div className="row HrForm">
              <div className="col-12 text-center HeaderExit">
                <h4>EXIT INTERVIEW FORM</h4>
              </div>

              <div className="row InterviewParra">
                <div className="col-12">
                  <p style={{ margin: 0, width: "100%" }}>
                    This questionnaire is designed to improvise the work culture
                    and organizational climate prevailing in UDS. Your sincere
                    advice will help us in making the work culture more
                    satisfying and fulfilling for our associates. We would
                    appreciate it if you would take a few minutes to respond to
                    the questions below. All answers will be held in strict
                    confidence. Thank you.
                  </p>
                </div>
              </div>
              <div className=" row tablePartInterview ">
                <div className="col-md-4">
                  <span>Name:</span>
                  <p>
                    {
                      state.ExitRetrieveCall?.ExitDataRetrieve?.user_id
                        ?.first_name
                    }
                    &nbsp;
                    {
                      state.ExitRetrieveCall?.ExitDataRetrieve?.user_id
                        ?.last_name
                    }
                  </p>
                </div>

                <div className="col-md-4">
                  <span>Designation:</span>
                  <p>
                    {
                      state.ExitRetrieveCall.ExitDataRetrieve?.user_id
                        ?.user_role?.role
                    }
                  </p>
                </div>
                <div className="col-md-4">
                  <span>Department:</span>
                  <p>{state.ExitRetrieveCall.ExitDataRetrieve?.department}</p>
                </div>
                <div className="col-md-4">
                  <span>Branch:</span>
                  <p>
                    {
                      state.ExitRetrieveCall.ExitDataRetrieve?.client_id
                        ?.client_name
                    }
                  </p>
                </div>
                <div
                  className="col-md-4"
                  style={{
                    flexDirection: "column",
                  }}
                >
                  <span>Period of service in UDS:</span>
                  <input type="text" name="name" id="" />
                </div>
                <div
                  className="col-md-4 "
                  style={{
                    flexDirection: "column",
                  }}
                >
                  <span>Resigning / Termination:</span>
                  <input type="text" name="name" id="" />
                </div>
              </div>

              <div className="row Questions QuestionsHrFormsUDS">
                {questionsWithNames?.map(({ name, label }) => (
                  <div key={name} className="col-12">
                    <h5>
                      <strong>{label}</strong>
                    </h5>
                    <textarea
                      name={name}
                      className="HRInterviewField"
                      value={data[name] != undefined ? data[name] : ""}
                      onChange={(e) => handleTextChange(e)}
                    />
                  </div>
                ))}
                <div className="row  following following06questons">
                  <div className="col-12">
                    <h5>
                      <strong>
                        6. If you are leaving for a better position, what makes
                        it more attractive than the one you are holding?
                      </strong>
                    </h5>
                  </div>

                  {options.map((option) => (
                    <div className="col-md-6" key={option}>
                      <input
                        id={`checkbox-${option}`}
                        type="checkbox"
                        value={option}
                        checked={data?.question_6?.includes(option)}
                        name="question_6"
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor={`checkbox-${option}`}>{option}</label>
                    </div>
                  ))}
                </div>
                <div className=" row followingYESNO">
                  <div className="col-12 ReConsider">
                    <h5>
                      <strong>
                        7. Would you re-consider employment with UDS?
                      </strong>
                    </h5>
                  </div>
                  <div className="col-md-6 innerColPart">
                    <input
                      type="checkbox"
                      checked={data.question_7}
                      onChange={() => {
                        setData({
                          ...data,
                          question_7: !data.question_7,
                        });
                      }}
                    />
                    <label htmlFor="question_7_yes">Yes</label>
                  </div>
                  <div className="col-md-6 innerColPart">
                    <input
                      type="checkbox"
                      checked={!data.question_7}
                      onChange={() => {
                        setData({
                          ...data,
                          question_7: !data.question_7,
                        });
                      }}
                    />
                    <label htmlFor="question_7_no">No</label>
                  </div>
                </div>
                {/* ----------Question 8---------- */}
                <div className="row following" id="EightQuestions">
                  <div className="col-12">
                    <h5>
                      <strong>8. How would you rate the following?</strong>
                    </h5>
                  </div>
                </div>
                <div className="row followingQuestions">
                  <div className="col-md-5"></div>
                  <div className="col-md-2">Good</div>
                  <div className="col-md-2">Poor</div>
                  <div className="col-md-2">Comments</div>
                  {questions.map((question, index) => (
                    <div className="row InnerQuestionsCount1" key={index}>
                      <div className="col-md-5">{question.label}</div>
                      <div className="col-md-2">
                        <input
                          type="checkbox"
                          checked={checkboxAnswers[question.label]}
                          onChange={(e) =>
                            handleRateCheckboxChange(
                              question.label,
                              e.target.checked
                            )
                          }
                          value={checkboxAnswers[question.label]}
                        />
                        <label>Yes</label>
                      </div>
                      <div className="col-md-2">
                        <input
                          type="checkbox"
                          checked={!checkboxAnswers[question.label]}
                          onChange={(e) =>
                            handleRateCheckboxChange(
                              question.label,
                              !e.target.checked
                            )
                          }
                          value={checkboxAnswers[question.label]}
                        />

                        <label>No</label>
                      </div>
                      <div className="col-md-2 dashedPart">
                        <input
                          type="text"
                          value={inputAnswers[question.label]}
                          onChange={(e) =>
                            handleInputChange(question.label, e.target.value)
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
                {/* ----------Question 9 to 10---------- */}
                {questionsWithNamesPart.map(({ name, label }) => (
                  <div key={name} className="col-12">
                    <h5>
                      <strong>{label}</strong>
                    </h5>
                    <textarea
                      name={name}
                      className="HRInterviewField"
                      value={data[name]}
                      onChange={(e) => handleTextChange(e, name)}
                    />
                  </div>
                ))}

                <div className="row SignatureHRInterview">
                  <div>
                    <h4>Interviewer signature </h4>
                  </div>
                  <div>
                    <h4>Employee signature </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HrinterviewForm;
